import { useTranslation } from "react-i18next";

const FamilyName = ({
  familyNameIsValid,
  setFamilyName,
  familyName,
  label,
  required,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <div className="form-group">
      <label>
        {label}
        {required && <span>*</span>}
      </label>
      <input
        type="text"
        value={familyName}
        onChange={(evt) => {
          setFamilyName(evt.target.value);
        }}
        {...props}
      />
      {!familyNameIsValid && (
        <div className="valid-message">{t("auth.familyName.validMessage")}</div>
      )}
    </div>
  );
};

export default FamilyName;
